"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Storage = void 0;
var Storage;
(function (Storage) {
    class StorageController {
        static saveToStorage(name, content) {
            localStorage.setItem(name, JSON.stringify(content));
        }
        static getFromStorage(name) {
            const data = localStorage.getItem(name);
            if (data === null) {
                return null;
            }
            return JSON.parse(data);
        }
        static removeFromStorage(name) {
            localStorage.removeItem(name);
        }
    }
    Storage.StorageController = StorageController;
})(Storage || (exports.Storage = Storage = {}));
